import { Nullable } from 'shared/types/global';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

//Helper
const safeLocalStorageOperation = <T>(operation: () => T, fallback: T): T => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return operation();
    }
  } catch (error) {
    console.error('LocalStorage operation failed:', error);
  }
  return fallback;
};

export const setTokenToLocalStorage = (token: string): void => {
  safeLocalStorageOperation(() => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  }, undefined);
};

export const getTokenFromLocalStorage = (): Nullable<string> => {
  return safeLocalStorageOperation(() => {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }, null);
};

export const setRefreshTokenToLocalStorage = (token: string): void => {
  safeLocalStorageOperation(() => {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }, undefined);
};

export const getRefreshTokenFromLocalStorage = (): Nullable<string> => {
  return safeLocalStorageOperation(() => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }, null);
};

export const removeTokenFromLocalStorage = (): void => {
  safeLocalStorageOperation(() => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }, undefined);
};

export const removeRefreshTokenFromLocalStorage = (): void => {
  safeLocalStorageOperation(() => {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }, undefined);
};

export const clearAllTokensInLocalStorage = (): void => {
  removeTokenFromLocalStorage();
  removeRefreshTokenFromLocalStorage();
};

export const hasLocalStorageValidTokens = (): boolean => {
  const accessToken = getTokenFromLocalStorage();
  const refreshToken = getRefreshTokenFromLocalStorage();

  return !!(accessToken && refreshToken);
};

export const hasLocalStorageAccessToken = (): boolean => {
  const accessToken = getTokenFromLocalStorage();
  return !!accessToken;
};

export const setTokensToLocalStorage = (
  accessToken: string,
  refreshToken: string
): void => {
  setTokenToLocalStorage(accessToken);
  setRefreshTokenToLocalStorage(refreshToken);
};

export const getTokensFromLocalStorage = (): {
  accessToken: Nullable<string>;
  refreshToken: Nullable<string>;
} => {
  return {
    accessToken: getTokenFromLocalStorage(),
    refreshToken: getRefreshTokenFromLocalStorage(),
  };
};
